// El free tier de ngrok devuelve una página HTML de advertencia (ERR_NGROK_6024) en vez de
// proxyar, salvo que la request lleve el header "ngrok-skip-browser-warning". Como este front
// llama a NBAPI con fetch crudo desde ~10 archivos distintos, se parchea fetch UNA sola vez acá
// (importado primero en index.js) en vez de tocar cada call site.
//
// Alcance deliberadamente mínimo, para no afectar el flujo actual del checkout:
// - Solo se agrega el header cuando la URL es string y empieza con REACT_APP_API_BASE_URL
//   (requests a otros destinos, o hechos con objetos Request, quedan intactos).
// - Contra un backend que no es ngrok el header es inofensivo (NBAPI tiene CORS con headers "*",
//   y los POST con Content-Type: application/json ya disparaban preflight igual).
// - Cualquier error del parche cae al fetch original sin modificar nada.

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const originalFetch = window.fetch.bind(window);

window.fetch = (input, init) => {
  try {
    if (API_BASE && typeof input === 'string' && input.startsWith(API_BASE)) {
      init = {
        ...(init || {}),
        headers: {
          'ngrok-skip-browser-warning': 'true',
          ...((init && init.headers) || {}),
        },
      };
    }
  } catch (_) {
    // nunca romper un request del checkout por culpa de este parche
  }
  return originalFetch(input, init);
};
